var React = require('react');

function ArrowForwardYellow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z","fill":"#FFD301"}));
}

ArrowForwardYellow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowForwardYellow;

ArrowForwardYellow.default = ArrowForwardYellow;
